import React from 'react';
import times from 'lodash/times';
import TableRow from '@material-ui/core/TableRow';
import TableCell from 'components/tables/tableCell';
import Checkbox from 'components/forms/Checkbox';
import { PAGE_SIZE } from 'constants/config';

export default () => times(PAGE_SIZE, i => (
  <TableRow
    className="material-table__row placeholder"
    role="checkbox"
    key={i}
    tabIndex={-1}
  >
    <TableCell className="material-table__row__cell" padding="checkbox">
      <Checkbox />
    </TableCell>
    <td className="material-table__row__cell full-name"><div /></td>
    <td className="material-table__row__cell email"><div /></td>
    <td className="material-table__row__cell company"><div /></td>
    <td className="material-table__row__cell industries"><div /></td>
  </TableRow>
));
